import { gql } from "@apollo/client";

/**
 * Get all visitors for a space, optionally filtered by widget
 */
export const GET_VISITORS = gql`
  query GetVisitors($spaceId: ID!, $widgetId: ID, $limit: Int, $offset: Int) {
    getVisitors(
      spaceId: $spaceId
      widgetId: $widgetId
      limit: $limit
      offset: $offset
    ) {
      id
      sessionId
      widgetId
      widget {
        id
        script_id
        business_details {
          display_name
        }
      }
      spaceId
      clientId

      # Network information
      ip
      country
      city
      region
      timezone

      # Device information
      browser
      browserVersion
      os
      device
      userAgent
      language
      screenResolution

      # Tracking information
      firstSeen
      lastSeen
      lastActiveAt
      totalPageViews
      pageViews {
        url
        title
        viewedAt
        duration
      }
      isOnline

      # Visitor information
      name
      email
      phone
      company

      # Chat session link
      chatSessionId

      createdAt
      updatedAt
    }
  }
`;

/**
 * Get a single visitor by ID
 */
export const GET_VISITOR = gql`
  query GetVisitor($id: ID!) {
    getVisitor(id: $id) {
      id
      sessionId
      widgetId
      widget {
        id
        script_id
        business_details {
          display_name
        }
      }
      spaceId
      clientId

      # Network information
      ip
      country
      city
      region
      timezone

      # Device information
      browser
      browserVersion
      os
      device
      userAgent
      language
      screenResolution

      # Tracking information
      firstSeen
      lastSeen
      lastActiveAt
      totalPageViews
      pageViews {
        url
        title
        viewedAt
        duration
      }
      isOnline

      # Visitor information
      name
      email
      phone
      company

      # Chat session link
      chatSessionId

      createdAt
      updatedAt
    }
  }
`;

/**
 * Get a visitor by session ID
 */
export const GET_VISITOR_BY_SESSION = gql`
  query GetVisitorBySession($sessionId: String!) {
    getVisitorBySession(sessionId: $sessionId) {
      id
      sessionId
      widgetId
      widget {
        id
        script_id
        business_details {
          display_name
        }
      }
      spaceId
      clientId

      # Network information
      ip
      country
      city
      region
      timezone

      # Device information
      browser
      browserVersion
      os
      device
      userAgent
      language
      screenResolution

      # Tracking information
      firstSeen
      lastSeen
      lastActiveAt
      totalPageViews
      pageViews {
        url
        title
        viewedAt
        duration
      }
      isOnline

      # Visitor information
      name
      email
      phone
      company

      # Chat session link
      chatSessionId

      createdAt
      updatedAt
    }
  }
`;
